// jgd-collection-index — nahtloses Zusammenführen über der statischen Pagination.
//
// Die Section rendert server-seitig echte Pagination-Links (SEO/No-JS-Pfad).
// Die Seitennaht liegt mitten im Buchstaben (das Paginate-Fenster schneidet
// Roh-Einträge, nicht Gruppen) — händisch benutzt sähe die Pagination daher
// fehlerhaft aus (Buchstabe auf beiden Seiten). Deshalb versteckt dieses
// Element die Pagination SOFORT und lädt unmittelbar alle Folgeseiten per
// Section Rendering API nach, bis die Liste komplett ist. Die Gruppe an der
// Seitennaht (z. B. S auf Seite 1 UND 2) wird in die bestehende Gruppe
// gemergt statt mit doppelter Überschrift angehängt.
// Einstieg auf Seite > 1 (Deeplink): vordere Seiten fehlen im DOM — die
// Pagination bleibt als Rückweg sichtbar, nachgeladen wird nur vorwärts.
// Schlägt ein Fetch fehl, erscheint die Pagination wieder (No-JS-Pfad).
//
// WICHTIG: Dieses Paginate nutzt einen SCOPED Seitenparameter
// (`page_<hash>=N`, nicht `?page=N`) — `?page=` wird ignoriert. Deshalb
// folgt das Script den Hrefs aus der gerenderten Pagination, statt URLs
// selbst zu bauen; jede nachgeladene Seite liefert den Href ihrer
// Folgeseite gleich mit.

class JgdCollectionIndex extends HTMLElement {
  connectedCallback() {
    if (this._started) return;
    this.startPage = parseInt(this.dataset.page || '1', 10) || 1;
    this.pagination = this.querySelector('.pagination');
    this.nextUrl = this.findNextUrl(this);
    if (!this.pagination || !this.nextUrl) return;

    this._started = true;
    if (this.startPage === 1) this.pagination.hidden = true;
    this.loadAll();
  }

  /**
   * Href des Weiter-Pfeils (letztes Pagination-Item). Auf der letzten Seite
   * rendert das Stock-Snippet dort einen <span> statt <a> → null = fertig.
   * @param {ParentNode} root Element oder Document (Section-Rendering-Antwort)
   */
  findNextUrl(root) {
    const anchor = root.querySelector(
      '.pagination .pagination__item:last-child a.pagination__link--arrow'
    );
    return anchor?.getAttribute('href') || null;
  }

  async loadAll() {
    try {
      while (this.nextUrl) {
        const url = new URL(this.nextUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId || '');
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        this.merge(doc);
        this.nextUrl = this.findNextUrl(doc);
      }
    } catch {
      // Fallback: Pagination wieder anzeigen, die statischen Links bleiben
      // der Weg zu den restlichen Seiten.
      this.pagination.hidden = false;
    }
  }

  /** @param {Document} doc Section-Rendering-Antwort der nächsten Seite */
  merge(doc) {
    const target = this.querySelector('.jgd-collection-index__groups');
    if (!target) return;

    for (const group of doc.querySelectorAll('.jgd-collection-index__group')) {
      const letter = group.querySelector('.jgd-collection-index__letter')?.textContent.trim();
      const lastGroup = target.lastElementChild;
      const lastLetter = lastGroup
        ?.querySelector('.jgd-collection-index__letter')
        ?.textContent.trim();

      if (letter && letter === lastLetter) {
        const source = group.querySelector('.jgd-collection-index__list');
        const destination = lastGroup.querySelector('.jgd-collection-index__list');
        if (source && destination) destination.append(...source.children);
      } else {
        target.append(group);
      }
    }
  }
}

if (!customElements.get('jgd-collection-index')) {
  customElements.define('jgd-collection-index', JgdCollectionIndex);
}
